import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { formatDateToTime, loadCss, showDatePassed2, localize } from "../../helpers/function";
import LoadingTable from "../components/LoadingTable";
import appConfig from "../../config/appConfig";
import Pagination from "../components/Pagination";
import EmptyTable from "../components/EmptyTable";
import HeaderTablePage from "../components/HeaderTablePage";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import { NUMBER_ELEMENT_PER_PAGE } from "../../constants/dataTable";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import HtmlDescription from "../components/DescriptionDetail/HtmlDescription";
import HtmlDescriptionModal from "../components/DescriptionDetail/HtmlDescriptionModal";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ls from "localstorage-slim";
import { use } from "i18next";
import { ToastBottomEnd } from "views/components/Toast";
import { toastErrorMessageWithParameterConfig } from "config/toastConfig";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const HistoricClaimsAdd = (props) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  document.title = "Satis client - " + (ready ? t("Paramètre Historique") : "");

  if (!verifyPermission(props.userPermissions, "history-list-create-claim")) {
    window.location.href = ERROR_401;
  }
  const [load, setLoad] = useState(true);
  const [claimsAdd, setClaimsAdd] = useState([]);
  const [numberPage, setNumberPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [searchable, setSearchable] = useState("");
  const [showList, setShowList] = useState([]);
  const [numberPerPage, setNumberPerPage] = useState(10);
  const [activeNumberPage, setActiveNumberPage] = useState(1);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentMessage, setCurrentMessage] = useState("");
  const [institutions, setInstitutions] = useState([]);
  const [institution, setInstitution] = useState({
    label: props.userInstitution?.name ?? "",
    value: props.userInstitution?.id ?? "",
  });
  const [collectors, setCollectors] = useState([]);
  const [collector, setCollector] = useState(null);

  let temp = JSON.parse(ls.get("userData"));
  let type_macro = temp.data.identite.staff?.institution.institution_type?.name;

  useEffect(() => {
    if (props.isHolding) {
      if (verifyTokenExpire()) {
        setLoad(true);
        axios
          .get(`${appConfig.apiDomaine}/history/list-claim/institutions`)
          .then(async (res) => {
            setInstitutions(
              res.data.map((item) => ({
                  label: item.name,
                  value: item.id,
                }))
                // .sort((a, b) => a.label.localeCompare(b.label))
            );
          })
          .catch((e) => {
            ToastBottomEnd.fire(toastErrorMessageWithParameterConfig(t("Une erreur est survenue")));
            console.log("error", e)
          });
      }
    }
  }, []);

  useEffect(() => {
    if (institutions.length > 0) {
      setInstitution(institutions.find(item => item.value === props.userInstitution.id) ?? null);
    }
  }, [institutions]);

  useEffect(() => {
    if (verifyTokenExpire()) {
      setLoad(true);
      axios
        .get(`${appConfig.apiDomaine}/history/list-claim/collectors?institution_id=${institution?.value??''}`)
        .then(async (res) => {
          setCollectors((prev) => [
            { label: t("-- VOIR TOUT --"), value: "all" },
            ...res.data?.map((item) => ({
              label: `${item?.identite?.firstname} ${item?.identite?.lastname}`,
              value: item?.id,
            })).sort((a, b) => a.label.localeCompare(b.label))
          ]);
        })
        .catch((e) => {
          setCollector(null);
          console.log("error", e)
        });
    }
  }, [institution]);

  useEffect(() => {
    if(collectors.length > 0) {
      if(verifyPermission(props.userPermissions, 'history-list-create-claim-any-collector')){
        setCollector(collectors[0]);
      }else{
        collectors.length > 1 ? setCollector(collectors[1]) : setCollector(collectors[0]);       
      }
    }
  }, [collectors]);

  const loadClaims = () => {
    if(!institution?.value || !collector?.value) return;
    setLoad(true);
    axios
      .get(
        `${appConfig.apiDomaine}/history/list-claim?institution_id=${institution?.value??''}${
          collector ? `&staff_id=${collector.value}` : ""
        }&page=${activeNumberPage}&size=${numberPerPage}${searchable?.length > 0 ? `&key=${searchable}` : ""}`
      )
      .then((response) => {
        setLoad(false);
        setShowList(response.data.data);
        setTotalData(response.data.total);
        setNumberPage(response.data.last_page);
        setPrevUrl(response.data.prev_page_url);
        setNextUrl(response.data.next_page_url);
      })
      .catch((error) => {
        setLoad(false);
      });
  }

  useEffect(() => {
    if (verifyTokenExpire()) {
      loadClaims();
    }
  }, [collector, searchable, numberPerPage, activeNumberPage, numberPage]);

  useEffect(() => {
    setActiveNumberPage(1);
  }, [collector, searchable]);

  const searchElement = async (e) => {
    setSearchable(e.target.value);
  };

  const onChangeNumberPerPage = (e) => {
    setActiveNumberPage(1);
    setNumberPerPage(parseInt(e.target.value));
  };


  const onClickPage = (e, page) => {
    e.preventDefault();
    setActiveNumberPage(page);
  };

  const onClickNextPage = (e) => {
    e.preventDefault();
    if (activeNumberPage <= numberPage && nextUrl !== null) {
      setActiveNumberPage(activeNumberPage + 1);
    }
  };

  const onClickPreviousPage = (e) => {
    e.preventDefault();
    if (activeNumberPage >= 1 && prevUrl !== null) {
      setActiveNumberPage(activeNumberPage - 1);
    }
  };


  const pages = (() => {
    const nb_p = [];
    for (let i = 0; i < numberPage; i++) {
      nb_p[i] = i;
    }
    return nb_p;
  })()

  const showModal = (message) => {
    setCurrentMessage(message);
    document.getElementById("button_modal").click();
  };

  const printBodyTable = (claim, index) => {
    return (
      <tr key={index} role="row" className="odd">
        <td>{claim.reference} </td>
        <td>
          {claim.claimer?.raison_sociale
            ? claim.claimer?.raison_sociale
            : (claim.claimer?.lastname ? claim.claimer.lastname : "") +
              " " +
              (claim.claimer?.firstname ? claim.claimer.firstname : "")}
          {claim.account_targeted
            ? " / " + claim.account_targeted.number
            : claim.account_number
            ? " / " + claim.account_number
            : ""}
        </td>
        <td>{claim.claim_object ? localize(claim.claim_object.name) : ""}</td>
        <td style={{ textAlign: "center" }}>
          <HtmlDescription
            onClick={() =>
              showModal(claim.description ? claim.description : "-")
            }
          />
        </td>
        {/*<td>{claim.description.length > 15 ? reduceCharacter(claim.description) : claim.description}</td>*/}
        <td>
          {props.plan === "PRO" || type_macro === "filiale"
            ? claim.unit_targeted
              ? localize(claim.unit_targeted.name)
              : "-"
            : claim.institution_targeted.name}
        </td>
        <td>
          {formatDateToTime(claim.received_at)} <br />
          {showDatePassed2(claim)}
        </td>
        <td style={{ textAlign: "center" }}>
          {claim.status === "archived" ? (
            <span className="kt-badge kt-badge--inline kt-badge--dark">
              {t("Archivé")}
            </span>
          ) : claim.status === "closed" ? (
            <span className="kt-badge kt-badge--inline kt-badge--dark">
              {t("Clôturé")}
            </span>
          ) : claim.status === "validated" ? (
            <span className="kt-badge kt-badge--inline kt-badge--success h2">
              {t("Validé")}
            </span>
          ) : (claim?.status ? claim.status : "") === "incomplete" ? (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("Incomplète")}
            </span>
          ) : (claim?.status ? claim.status : "") === "full" ? (
            <span className="kt-badge kt-badge--inline kt-badge--primary h2">
              {t("Complète")}
            </span>
          ) : (claim?.status ? claim.status : "") === "transferred_to_unit" ? (
            <span className="kt-badge kt-badge--inline kt-badge--unified-dark h2">
              {t("Transférer à une unité")}
            </span>
          ) : (claim?.status ? claim.status : "") === "assigned_to_staff" ? (
            <span className="kt-badge kt-badge--inline kt-badge--info h2">
              {t("Assigner à un staff")}
            </span>
          ) : (claim?.status ? claim.status : "") === "treated" ? (
            <span className="kt-badge kt-badge--inline kt-badge--success h2">
              {t("Traité")}
            </span>
          ) : (claim?.status ? claim.status : "") === "considered" ? (
            <span className="kt-badge kt-badge--inline kt-badge--success h2">
              {t("Considéré")}
            </span>
          ) : (claim?.status ? claim.status : "") === "awaiting" ? (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("En attente")}
            </span>
          ) : (claim?.status ? claim.status : "") === "unsatisfied" ? (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("Traité et insatisfait")}
            </span>
          ) : (claim?.status ? claim.status : "") ===
            "transferred_to_staff_for_satisfactiion" ? (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("En attente de mesure de satisfaction")}
            </span>
          ) : (
            <span className="kt-badge kt-badge--inline kt-badge--warning h2">
              {t("En cours de traitement")}
            </span>
          )}
        </td>
        <td>
          <a
            href={`/process/claims/${claim.reference}/detail`}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Détails")}
          >
            <i className="la la-eye" />
          </a>
          {/*{verifyPermission(props.userPermissions, "update-claim") ? (*/}
            
          {/*) : null}*/}
        </td>
      </tr>
    );
  };
  const onChangeCollector = (selected) => {
    setCollector(selected);
  };

  const onChangeInstitution = (selected) => {
    setInstitution(selected);
  };

  return ready ? (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Historiques")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#icone" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <a
                href="#button"
                onClick={(e) => e.preventDefault()}
                className="kt-subheader__breadcrumbs-link"
              >
                {t("Réclamations créées")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet">
          <HeaderTablePage title={t("Réclamations créées")} />


          <div id="kt_table_1_wrapper" className="pl-5 pt-3">
            {props.isHolding ?
            <div className="row pr-4 mb-5">
              <div className="col col-6  pl-0 pr-3">
                <div className="col">
                  <label htmlFor="staff">{t("Institution (s) ")}</label>
                  <Select
                    isClearable
                    placeholder={t("Veuillez sélectionner l'institution")}
                    value={institution}
                    onChange={onChangeInstitution}
                    isLoading={load}
                    options={institutions}
                  />
                </div> 
              </div>
            </div>
            : null}

            <div className="row pr-4">
              <div className="col col-6 pl-0 pr-3">
                <div className={"col"}>
                  <label htmlFor="staff">{t("Collecteur (s) ")}</label>
                  <Select
                    isClearable
                    placeholder={t("Veuillez sélectionner l'agent")}
                    value={collector}
                    onChange={onChangeCollector}
                    isLoading={load}
                    options={collectors}
                  />
                </div>
              </div> 

              <div
                className="col-sm-6 pt-3"
                style={{ paddingLeft: "14rem", paddingRight: "2rem" }}
              >
                <div id="kt_table_1_filter" className="dataTables_filter">
                  <label className="w-100">
                    {t("Recherche")}:
                    <input
                      id="myInput"
                      type="text"
                      onKeyUp={(e) => searchElement(e)}
                      className="form-control form-control-sm w-100"
                      placeholder=""
                      aria-controls="kt_table_1"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          {load ? (
            <LoadingTable />
          ) : (
            <div className="kt-portlet__body">
              <div
                id="kt_table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="row">
                  <div className="col-sm-12">
                    <table
                      className="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline"
                      id="myTable"
                      role="grid"
                      aria-describedby="kt_table_1_info"
                      style={{ width: "952px" }}
                    >
                      <thead>
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "50px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Référence")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "50px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Réclamant")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "80px", maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Objets de réclamation")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "100px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Description de la Réclamation")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "70px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {props.plan === "PRO" || type_macro === "filiale"
                              ? t("Point de service visé")
                              : t("Institution ciblée")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "70px" }}
                            aria-label="Country: activate to sort column ascending"
                          >
                            {t("Date de réception")}
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "70px" }}
                            aria-label="Ship City: activate to sort column ascending"
                          >
                            {t("Statut")}
                          </th>

                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="kt_table_1"
                            rowSpan="1"
                            colSpan="1"
                            style={{ width: "25px" }}
                            aria-label="Type: activate to sort column ascending"
                          >
                            {t("Action")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {showList.length > 0 ? (
                          showList.map((claim, index) =>
                            printBodyTable(claim, index)
                          )
                        ) : (
                          <EmptyTable />
                        )}
                      </tbody>
                      <tfoot>
                        <tr style={{ textAlign: "" }}>
                          <th rowSpan="1" colSpan="1">
                            {t("Référence")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Réclamant")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Objets de réclamtions")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Description")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {props.plan === "PRO" || type_macro === "filiale"
                              ? t("Point de service visé")
                              : t("Institution ciblée")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Date de réception")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Statut")}
                          </th>
                          <th rowSpan="1" colSpan="1">
                            {t("Action")}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                    <button
                      id="button_modal"
                      type="button"
                      className="btn btn-secondary btn-icon-sm d-none"
                      data-toggle="modal"
                      data-target="#message_email"
                    />
                    <HtmlDescriptionModal
                      title={t("Description")}
                      message={currentMessage}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-5">
                    <div
                      className="dataTables_info"
                      id="kt_table_1_info"
                      role="status"
                      aria-live="polite"
                    >
                      {t("Affichage de")} {showList.length} {t("sur")}{" "}
                      {totalData} {t("données")}
                    </div>
                  </div>

                  {showList.length ? (
                    <div className="col-sm-12 col-md-7 dataTables_pager">
                      <Pagination
                        numberPerPage={numberPerPage}
                        onChangeNumberPerPage={onChangeNumberPerPage}
                        activeNumberPage={activeNumberPage}
                        onClickPreviousPage={(e) => onClickPreviousPage(e)}
                        pages={pages}
                        onClickPage={(e, number) => onClickPage(e, number)}
                        numberPage={numberPage}
                        onClickNextPage={(e) => onClickNextPage(e)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : null;
};
const mapStateToProps = (state) => {
  
  return {
    plan: state.plan.plan,
    userStaff: state?.user?.user?.staff,
    userPermissions: state.user.user.permissions,
    userInstitution: state?.user?.user?.institution,
    isHolding: state?.user?.user?.institution?.institution_type?.name === "holding",
  };
};

export default connect(mapStateToProps)(HistoricClaimsAdd);
